import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ExerciseListHead } from '@widgets/exercises';
import { ProgramListFilter } from '@widgets/programs';
import { useFilter } from '@features/common/index.ts';
import { ExerciseList } from '@features/exercises';
import { useExerciseEditFormPagesRedirect } from '@features/exercises/exercise-form/model/helpres.ts';
import { useExercisesListSavedData } from '@features/exercises/exercise-list/helprs.ts';
import { useMobileVisibilityFilter } from '@features/programs/index.ts';
import { ListBody } from '@shared/ui';
import * as st from './styles.module.scss';

export const Exercises: React.FC = () => {
  const { doRedirectWithSavePageUrl } = useExerciseEditFormPagesRedirect();
  const { code } = useParams<{ code: string }>();
  const { data, doRemoveStorageData } = useExercisesListSavedData();
  const isOneVideoSelectRef = useRef(data?.isOneVideoSelect);
  useEffect(() => {
    return () => {
      doRemoveStorageData();
    };
  }, []);

  const {
    partitions,
    selectedAuthors,
    onAuthorChange,
    selectedTags,
    onTagChange,
    search,
    onSearch,
    tags,
    selectedPartitions,
    onPartitionsChange,
    handleResetFilter,
    isFilterActive,
    showFilterBar,
    setShowFilterBar,
  } = useFilter();

  const [titles, setTitles] = useState<Array<string>>([]);

  const addVideo = (): void => {
    doRedirectWithSavePageUrl(`/programs/${code}/exercise-edit/new`, {
      state: { isDisabledSelectionFromLibrary: true },
    });
  };

  const { mobileWithFilterOn, setMobileWithFilterOn } = useMobileVisibilityFilter(showFilterBar);

  return (
    <>
      <ExerciseListHead
        showFilterBar={showFilterBar}
        isFilterActive={isFilterActive}
        setMobileWithFilterOn={setMobileWithFilterOn}
        mobileWithFilterOn={mobileWithFilterOn}
        search={search}
        onSearch={onSearch}
        titles={titles}
        addVideo={addVideo}
        setShowFilterBar={setShowFilterBar}
        handleResetFilter={handleResetFilter}
        filterBtnIsActive={isFilterActive || showFilterBar}
      />
      <ListBody>
        <div className={cn(st.main, !showFilterBar && st.hideBar)}>
          <ProgramListFilter
            partitions={partitions}
            tags={tags}
            isOpen={showFilterBar}
            selectedTags={selectedTags}
            onTagChange={onTagChange}
            selectedAuthors={selectedAuthors}
            onAuthorChange={onAuthorChange}
            hasResetButton={isFilterActive}
            handleResetFilter={handleResetFilter}
            onPartitionChange={(id) => onPartitionsChange([id])}
            selectedPartitions={selectedPartitions}
            activeTab={'my'}
          />

          <div className={cn(st.list, mobileWithFilterOn && st.hide)}>
            <ExerciseList
              isOneVideoSelect={isOneVideoSelectRef.current}
              forQuery={{
                search,
                tags: selectedTags.length ? selectedTags.join(' ,') : undefined,
                partitions: selectedPartitions.length ? selectedPartitions.join(' ,') : undefined,
                setTitles: setTitles,
              }}
              showFilterBar={showFilterBar}
            />
          </div>
        </div>
      </ListBody>
    </>
  );
};
